"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmploymentIncomeSource = void 0;
var EmploymentIncomeSource;
(function (EmploymentIncomeSource) {
    EmploymentIncomeSource["BASE"] = "B";
    EmploymentIncomeSource["BONUS"] = "BO";
    EmploymentIncomeSource["COMMISSION"] = "COM";
    EmploymentIncomeSource["MILITARY"] = "MIL";
    EmploymentIncomeSource["OVERTIME"] = "OT";
    EmploymentIncomeSource["RENT"] = "RENT";
    EmploymentIncomeSource["SECOND"] = "SEC";
    EmploymentIncomeSource["SELF"] = "SE";
})(EmploymentIncomeSource = exports.EmploymentIncomeSource || (exports.EmploymentIncomeSource = {}));
